import { ua } from './ua';
import { isWxChat } from './wechat';
import { isMobile } from './platform';

/**
 * 是否在UMU App Web环境内
 */
export const isUMUWebview: boolean = /umu/i.test(ua);

/**
 * 获取UMU App客户端Web容器版本
 */
const umuUAVersion = new RegExp(/UMU\/(.*)$/i).exec(ua);
export const umuClientVersion = umuUAVersion ? umuUAVersion[1] : '';

/**
 * 是否是【个人微信】和【umu app】环境
 */
export const isUmuWx = isUMUWebview || isWxChat;

/**
 * 移动设备 浏览器，微信
 */
export function isInMobile() {
    return isMobile;
}

/**
 * pc 浏览器
 */
export function isInDesktop() {
    return !(isInApp() || isInMobile());
}

/**
 * umu app
 */
export function isInApp() {
    return isUMUWebview;
}

/**
 * 是否是企业版 APP
 */
export const isEntApp = isUMUWebview && /umu-ent/.test(ua);

/**
 * 是否为UMU sandbox环境
 */
export const isSandbox = location.href.indexOf('sandbox.umucdn.cn') !== -1;

/**
 * UMU 企业版 APP 版本号
 * @returns 1.0.0 | ''
 */
export const getEntAppVersion = () => {
    const matchRes = ua.match(/ umu-ent\/([0-9]|\.)*/);
    if (matchRes) {
        return matchRes[0].replace(' umu-ent/', '');
    }
    return '';
};

/**
 * UMU APP 版本号
 * @returns 1.0.0 | ''
 */
export const getAppVersion = () => {
    const matchRes = ua.match(/ umu\/([0-9]|\.)*/);
    if (matchRes) {
        return matchRes[0].replace(' umu/', '');
    }
    return '';
};

/**
 * 5.17.0 => 51700
 * @param version 
 * @returns numher
 */
export const getAppNumVersion = () => {
    const version = getAppVersion();
    const appVersion = version.split('.');
    const lv = appVersion[0];
    const mv = Number(appVersion[1]) > 9 ? appVersion[1] : '0' + appVersion[1];
    const sv = Number(appVersion[2]) > 9 ? appVersion[2] : '0' + appVersion[2];
    return Number(lv + mv + sv);
};
